<template>
    <div class="dashboard-mod">
        <h4>{{ $t("reolinkLab.subTitle") }}</h4>
        <h2>{{ $t("reolinkLab.title") }}</h2>
        <applyLab v-if="showApplyLab" @backToDashboard="backToDashboard"></applyLab>
        <ul class="lab-des">
            <li class="des-item">
                <h5 class="des-title">{{ $t("reolinkLab.definition_title") }}</h5>
                <p class="des-content">{{ $t("reolinkLab.definition_content") }}</p>
            </li>

            <li class="des-item">
                <h5 class="des-title">{{ $t("reolinkLab.recording_title") }}</h5>
                <p class="des-content">{{ $t("reolinkLab.recording_content") }}</p>
                <ul class="recording-feature">
                    <li class="feature-item">
                        <h6 class="feature-title must-know">{{ $t("reolinkLab.recording_feature_title") }}</h6>
                        <div class="feature-content">
                            <p class="feature-point">{{ $t("reolinkLab.recording_point1_title") }}</p>
                            <p class="feature-detail">{{ $t("reolinkLab.recording_point1_detail") }}</p>
                        </div>
                        <div class="feature-content">
                            <p class="feature-point">{{ $t("reolinkLab.recording_point2_title") }}</p>
                            <p class="feature-detail">{{ $t("reolinkLab.recording_point2_detail") }}</p>
                        </div>
                    </li>
                    <li class="feature-item">
                        <h6 class="feature-title">{{ $t("reolinkLab.recording_device_title") }}</h6>
                        <p class="feature-detail">{{ $t("reolinkLab.recording_device_detail") }}</p>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="choice-btns" v-if="!showApplyLab">
            <button
                class="ui-button primary-button short-button"
                @click="backToDashboard">
                    {{ $t('reolinkLab.btn_no_interested') }}
            </button>

            <button
                class="ui-button empty-button short-button"
                @click="showApplyLab=true">
                    {{ $t('reolinkLab.btn_try_to') }}
            </button>
        </div>
    </div>
</template>

<script>
import applyLab from '@/components/applyLab.vue';

export default {

    components: {

        applyLab

    },

    data () {

        return {

            showApplyLab: false

        };

    },

    computed: {

        isApplied () {

            let labInfo = this.$store.getters.lab;

            return labInfo.status !== 'inactive' && labInfo.enabled;

        }

    },

    mounted () {

        window.scrollTo( 0, 0 );

    },

    methods: {
        backToDashboard () {

            this.$emit( 'backToDashboard' );

        }
    },

    watch: {

        isApplied: {

            handler ( n ) {

                if ( n ) {

                    this.showApplyLab = true;

                }

            },

            immediate: true

        }

    }

};
</script>

<style type="text/css" lang="less" scoped>

.dashboard-mod {
    padding-bottom: 0.7rem;
    & > div, & > ul {
        max-width: 7.6rem;
        margin-left: auto;
        margin-right: auto;
    }
    @media @mobile {
        padding: 1rem 0 0.88rem;
        & > div, & > ul {
            max-width: 100%;
        }
    }
    h4, h2, h5, h6 {
        font-weight: 500;
    }
    h4 {
        font-size: 0.22rem;
        text-align: center;
        @media @mobile {
            font-size: 0.36rem;
        }
    }
    h2 {
        font-size: 0.36rem;
        margin-top: 0.1rem;
        text-align: center;
        margin-bottom: 0.5rem;
        @media @mobile {
            margin-top: 0.16rem;
            font-size: 0.5rem;
            margin-bottom: 0.6rem;
        }
    }
    .lab-des {
        line-height: 1.3;
        .des-item {
            & + .des-item {
                margin-top: 0.4rem;
            }
            .des-title {
                font-size: 0.22rem;
            }
            .des-content {
                margin-top: 0.16rem;
                font-size: 0.16rem;
            }
            .recording-feature {
                .feature-item {
                    font-size: 0.16rem;
                    margin-top: 0.3rem;
                    .feature-title {
                        font-size: 0.18rem;
                        margin-bottom: 0.16rem;
                        &.must-know {
                            color: #E74330;
                        }
                    }
                    .feature-content {
                        & + .feature-content {
                            margin-top: 0.16rem;
                        }
                        .feature-point {
                            color: #E74330;
                        }
                    }
                }
            }
        }
        @media @mobile {
            line-height: 1.4;
            .des-item {
                & + .des-item {
                    margin-top: 0.5rem;
                }
                .des-title {
                    font-size: 0.32rem;
                }
                .des-content {
                    margin-top: 0.3rem;
                    font-size: 0.26rem;
                }
                .recording-feature {
                    .feature-item {
                        font-size: 0.26rem;
                        margin-top: 0.4rem;
                        .feature-title {
                            font-size: 0.28rem;
                            margin-bottom: 0.24rem;
                        }
                        .feature-content {
                            & + .feature-content {
                                margin-top: 0.24rem;
                            }
                        }
                    }
                }
            }
        }
    }
    .choice-btns {
        display: flex;
        justify-content: center;
        margin-top: 0.7rem;
        button + button {
            margin-left: 0.4rem;
        }
        @media @mobile {
            display: block;
            margin-top: 0.6rem;
            button {
                width: 100%;
                & + button {
                    margin-left: 0;
                    margin-top: 0.2rem;
                }
            }

        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/reolinkLab.vue